import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseViewerComponent } from '../base-viewer/base-viewer.component';

@Component({
    selector: 'sh-image-viewer',
    templateUrl: './image-viewer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ImageViewerComponent extends BaseViewerComponent {
    constructor() {
        super();
    }
}
